// redux/slices/vendorSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Vendor } from '../../interfaces/user';

interface VendorState {
  vendors: Vendor[];
  loading: boolean;
  error: string | null;
}

const initialState: VendorState = {
  vendors: [],
  loading: false,
  error: null
};

const vendorSlice = createSlice({
  name: 'vendor',
  initialState,
  reducers: {
    setVendors(state, action: PayloadAction<Vendor[]>) {
      state.vendors = action.payload;
    },
    addVendor(state, action: PayloadAction<Vendor>) {
      state.vendors.push(action.payload);
    },
    updateVendor(state, action: PayloadAction<Vendor>) {
      const index = state.vendors.findIndex(v => v.id === action.payload.id);
      if (index !== -1) state.vendors[index] = action.payload;
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    }
  }
});

export const { setVendors, addVendor, updateVendor, setLoading, setError } = vendorSlice.actions;
export default vendorSlice.reducer;
